module.exports = function($){
  $.FW   = true;
  $.path = $.g;
  return $;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-es6-polyfill/~/core-js/modules/$.fw.js
 ** module id = 530
 ** module chunks = 0
 **/